import axios from "axios";
import { SailModelsType } from "@/types/apiTypes";
import { API_BASE_URL } from "@/utils/api";

export const fetchSailModelsApi = async (): Promise<SailModelsType[]> => {
  const response = await axios.get<SailModelsType[]>(
    `${API_BASE_URL}/sail-models`,
  );
  return response.data;
};
